import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";

export class IncentiveTagCategory extends HasProjectMixin(Model) {
  static get $name() {
    return "IncentiveTagCategory";
  }

  static get fields() {
    return [
      { name: "name", dataSource: "name" },
      { name: "description", dataSource: "description" },
      { name: "color", dataSource: "color" },
      { name: "points", dataSource: "points", type: "number" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
    ];
  }
}
